var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 24C33.5 21.5147 35.5147 19.5 38 19.5C40.4853 19.5 42.5 21.5147 42.5 24C42.5 26.4853 40.4853 28.5 38 28.5C35.5147 28.5 33.5 26.4853 33.5 24Z",
    fill: "white",
    stroke: "#73737B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 14C29.5 11.5147 31.5147 9.5 34 9.5C36.4853 9.5 38.5 11.5147 38.5 14C38.5 16.4853 36.4853 18.5 34 18.5C31.5147 18.5 29.5 16.4853 29.5 14Z",
    fill: "white",
    stroke: "#73737B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10C19.5 7.51472 21.5147 5.5 24 5.5C26.4853 5.5 28.5 7.51472 28.5 10C28.5 12.4853 26.4853 14.5 24 14.5C21.5147 14.5 19.5 12.4853 19.5 10Z",
    fill: "white",
    stroke: "#73737B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 38C19.5 35.5147 21.5147 33.5 24 33.5C26.4853 33.5 28.5 35.5147 28.5 38C28.5 40.4853 26.4853 42.5 24 42.5C21.5147 42.5 19.5 40.4853 19.5 38Z",
    fill: "white",
    stroke: "#73737B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 34C9.5 31.5147 11.5147 29.5 14 29.5C16.4853 29.5 18.5 31.5147 18.5 34C18.5 36.4853 16.4853 38.5 14 38.5C11.5147 38.5 9.5 36.4853 9.5 34Z",
    fill: "white",
    stroke: "#73737B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 24C5.5 21.5147 7.51472 19.5 10 19.5C12.4853 19.5 14.5 21.5147 14.5 24C14.5 26.4853 12.4853 28.5 10 28.5C7.51472 28.5 5.5 26.4853 5.5 24Z",
    fill: "white",
    stroke: "#73737B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.5 11.5147 11.5147 9.5 14 9.5C16.4853 9.5 18.5 11.5147 18.5 14C18.5 16.4853 16.4853 18.5 14 18.5C11.5147 18.5 9.5 16.4853 9.5 14Z",
    fill: "white",
    stroke: "#73737B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 34C29.5 31.5147 31.5147 29.5 34 29.5C36.4853 29.5 38.5 31.5147 38.5 34C38.5 36.4853 36.4853 38.5 34 38.5C31.5147 38.5 29.5 36.4853 29.5 34Z",
    fill: "white",
    stroke: "#73737B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#63C7C9",
    stroke: "#73737B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.b5554eba.svg";
export { ForwardRef as ReactComponent };